// extracted by mini-css-extract-plugin
export default {"title":"SignUp_title__WCyEO","description":"SignUp_description__oHA+g","form":"SignUp_form__5CxKy","requirements":"SignUp_requirements__iyLqw","link":"SignUp_link__dCCfn"};